import { connect } from "react-redux";
import NavbarComponent from "../components/NavbarComponent";
import { setIndicate } from "../messages/actions";
import { withRouter } from "react-router-dom";
import { getSelectedHotel } from "../hotels/selectors";
import { getHotels, selectHotel } from "../hotels/actions";
import { isSynchronizing, isAdmin } from "../users/selectors";
import { logout } from "../users/loggedUser/actions";
import { translate } from "react-i18next";
const mapStateToProps = (state, ownProps) => {
  return {
    user: state.account.user,
    activeTab: ownProps.activeTab,
    indicate: state.messages.indicate,
    hotels: state.hotels.data,
    hotel: getSelectedHotel(state),
    isSynchronizing: isSynchronizing(state),
    isAdmin: isAdmin(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {
      dispatch(logout());
      ownProps.history.push("/login");
    },
    setIndicate: () => {
      dispatch(setIndicate());
    },
    getHotels: () => {
      dispatch(getHotels());
    },
    selectHotel: hotel => {
      dispatch(selectHotel(hotel));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(translate("translations")(NavbarComponent))
);



// WEBPACK FOOTER //
// ./src/containers/NavbarContainer.js